import { useState, useEffect } from 'react';

const slides = [
  {
    title: 'O Nosso Negócio é Vender o Seu',
    subtitle: 'GUEPARDO AGENCIA',
    description: 'Assessoria completa em marketing digital 360º para impulsionar suas vendas',
    cta: 'Saiba Mais'
  },
  {
    title: 'Velocidade e Precisão em Marketing Digital',
    subtitle: 'GUEPARDO AGENCIA',
    description: 'Transformamos sua marca em líder de mercado com estratégias ágeis e resultados mensuráveis',
    cta: 'Solicitar Orçamento'
  },
  {
    title: 'Há 14 Anos Transformando Ideias em Resultados que Vendem',
    subtitle: 'GUEPARDO AGENCIA',
    description: 'Experiência comprovada em marketing digital com cases de sucesso em todo o Brasil e no mundo',
    cta: 'Conheça Nossos Cases'
  }
];

export function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 7000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 left-10 w-72 h-72 bg-amber-200 rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-amber-100 rounded-full filter blur-3xl animate-pulse delay-1000"></div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`transition-all duration-1000 ${
              index === currentSlide ? 'opacity-100 translate-y-0' : 'opacity-0 absolute translate-y-10 pointer-events-none'
            }`}
          >
            <p className="text-amber-200 font-semibold text-lg md:text-xl mb-4 tracking-wider animate-fade-in">
              {slide.subtitle}
            </p>
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-6 leading-tight animate-fade-in-up">
              {slide.title}
            </h2>
            <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto animate-fade-in-up delay-200">
              {slide.description}
            </p>
            <a
              href="https://api.whatsapp.com/send?phone=5519982674838&text=Olá, gostaria de saber mais sobre os serviços da GUEPARDO AGENCIA"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-200 to-amber-300 text-black px-10 py-5 rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-amber-200/50 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer animate-fade-in-up delay-300"
            >
              {slide.cta}
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>
        ))}

        <div className="flex justify-center gap-3 mt-16">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentSlide ? 'bg-amber-200 w-12' : 'bg-white/30 hover:bg-white/50'
              }`}
              aria-label={`Ir para slide ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>

      <button
        onClick={prevSlide}
        className="absolute left-6 bottom-8 text-white/70 hover:text-white transition-colors duration-300 w-12 h-12 flex items-center justify-center cursor-pointer"
        aria-label="Slide anterior"
      >
        <i className="ri-arrow-left-s-line text-3xl"></i>
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-6 bottom-8 text-white/70 hover:text-white transition-colors duration-300 w-12 h-12 flex items-center justify-center cursor-pointer"
        aria-label="Próximo slide"
      >
        <i className="ri-arrow-right-s-line text-3xl"></i>
      </button>

      <div className="absolute left-8 top-1/2 -translate-y-1/2 hidden lg:flex flex-col gap-6">
        <a href="https://www.instagram.com/guepardoagencia" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-amber-200 transition-colors duration-300 w-10 h-10 flex items-center justify-center cursor-pointer">
          <i className="ri-instagram-line text-2xl"></i>
        </a>
        <a href="https://api.whatsapp.com/send?phone=5519982674838&text=Olá, gostaria de saber mais sobre os serviços da GUEPARDO AGENCIA" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-amber-200 transition-colors duration-300 w-10 h-10 flex items-center justify-center cursor-pointer">
          <i className="ri-whatsapp-line text-2xl"></i>
        </a>
      </div>

      <button
        onClick={() => document.getElementById('sobre')?.scrollIntoView({ behavior: 'smooth' })}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70 hover:text-white transition-all duration-300 flex flex-col items-center gap-2 cursor-pointer animate-bounce"
      >
        <span className="text-sm font-medium whitespace-nowrap">Ver mais</span>
        <i className="ri-arrow-down-line text-2xl"></i>
      </button>
    </section>
  );
}
